import React, { useState, useContext } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import Floater from 'react-floater';
import { useDispatch } from 'react-redux';
import { Auth } from 'aws-amplify';
import { ThemeContext } from 'styled-components';
import {
  Button,
  Icon,
  Loader,
  InputCadastroSenha,
  TipPassword,
  TipCard,
  ModalClose,
} from '../../components';
import { icons } from '../../assets';
import * as s from './styled-reset-password';

const CadastrarNovaSenha = () => {
  const dispatch = useDispatch();
  const [username, setUsername] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirm, setNewPasswordConfirm] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [errorMessageCode, setErrorMessageCode] = useState('');
  const [errorMessagePassword, setErrorMessagePassword] = useState('');
  const [ modalConfirmation, setModalConfirmation ] = useState(false);
  const [loading, setLoading] = useState(false);
  const { colors } = useContext(ThemeContext);
  const history = useHistory();

  const messageByStatus = (e) => {
    if (e.code === 'UserNotFoundException') return 'Usuário não encontrado';
    // if (e.code === 'NotAuthorizedException') return 'Senha incorreta';
    if (e.code === 'InvalidParameterException')
      return 'Todos os campos devem ser prenchidos';
    return 'Ocorreu um erro...';
  };

  const onSubmit = (event) => {
    event.preventDefault();
    if (newPassword !== newPasswordConfirm) setErrorMessagePassword('Senha diferente');
    else if (newPassword.length < 8) setErrorMessagePassword('Sua senha deve conter no mínimo 8 caracteres');
    else {
      setLoading(true);
      Auth.forgotPasswordSubmit(username, code, newPassword)
        .then(() => {
          setLoading(false);
          setModalConfirmation(true);
        })
        .catch((e) => {
          setLoading(false);
          if (e.message === 'Invalid verification code provided, please try again.')
            setErrorMessageCode("Código de verificação inválido, por favor tente novamente")
          else if(e.message === 'Invalid code provided, please request a code again.')
            setErrorMessageCode("Código de verificação expirado, por favor solicite um novo código")
          else if(e.message === "Attempt limit exceeded, please try after some time.")
            setErrorMessageCode("Número de tentativas excedidas, por favor tente novamente mais tarde")
          else if (e.message === "Password does not conform to policy: Password must have numeric characters"
                || e.message === "Password does not conform to policy: Password must have lowercase characters"
                || e.message === "Password does not conform to policy: Password must have uppercase characters"
                || e.message === "Password does not conform to policy: Password must have symbol characters") 
            setErrorMessagePassword('A senha deve conter caracteres maiúsculos, minúsculos, númericos e especiais')
          else setErrorMessage(messageByStatus(e));
        });
    }
  };

  const loginRedirect = () =>{
    setModalConfirmation(false);
    dispatch({
      type: 'USUARIO/SET_ERROR',
      erro: '',
    });
    history.push('/login');
  }

  return ( 
      <s.Column>
      {modalConfirmation &&
        <ModalClose 
          labelClose="Senha alterada com sucesso!"
          labelButtonClose="CONCLUIR"
          colorClose={colors.lightblue}
          onClose={() => loginRedirect()}
        />
      }
        <TipCard icon={icons.KeyImageBackground}/>
        <s.Cmodel onSubmit={onSubmit}>
          <s.WrapperTitle>
            <s.Label>Cadastro de nova senha</s.Label>
          </s.WrapperTitle>
            <s.Wrapper input>
              <s.Label size="13px" bold>
                E-mail cadastrado
              </s.Label>
              <InputCadastroSenha
                type="email"
                size="18px"
                icon={<Icon name="mail" size={18} />}
                placeholder="Digite aqui o e-mail cadastrado"
                width="45vw"
                height="55px"
                errorMessage={errorMessage === '' ? `1px ${colors.surfaceMuted} solid` : `1px ${colors.red} solid`}
                value={username}
                onChange={(event) => {setUsername(event.target.value); setErrorMessage('')}}
                username
              />
            </s.Wrapper>
            <s.ErrorMessage size="12px" color={colors.red}>
              {errorMessage !== 1 && errorMessage}
            </s.ErrorMessage>
            <s.Wrapper input>
              <s.Label size="13px" bold>
                Código de segurança
              </s.Label>
              <InputCadastroSenha
                type="text"
                maxLength="6"
                size="18px"
                icon={<Icon name="lock" size={18} />}
                placeholder="Digite aqui o código de segurança"
                width="45vw"
                height="45"
                errorMessage={errorMessageCode === '' ? `1px ${colors.surfaceMuted} solid` : `1px ${colors.red} solid`}
                value={code}
                onChange={(event) => { setCode(event.target.value); setErrorMessageCode('')}}
                code
              />
            </s.Wrapper>
            <s.ErrorMessage size="12px" color={colors.red}>
              {errorMessageCode !== 1 && errorMessageCode}
            </s.ErrorMessage>
            <Floater
              className="floater"
              content={
                  <label style={{ fontSize: 15,}}>
                  * Conter no mínimo 8 caracteres <br/>
                  * Conter no máximo 10 caracteres <br/>
                  * Conter letras maiúsculas <br/>
                  * Conter letras minúsculas <br/>
                  * Conter números <br/>
                  * Conter caracteres especiais (ex: !@#%) <br/>
                  </label>
              }
              event="hover"
              hideArrow={true}
              offset={3}
            >
              <s.Wrapper input>
                <s.Label size="13px" bold>
                  Nova senha
                </s.Label>
                <InputCadastroSenha
                  type="password"
                  maxLength="10"
                  size="18px"
                  icon={<Icon name="key" size={18} />}
                  placeholder="Digite uma nova senha"
                  width="45vw"
                  height="45"
                  errorMessage={errorMessagePassword === '' ? `1px ${colors.surfaceMuted} solid` : `1px ${colors.red} solid`}
                  value={newPassword}
                  onChange={(event) => { setNewPassword(event.target.value);  setErrorMessagePassword('')}}
                  new_password
                />
              </s.Wrapper>
            </Floater>
            <s.Wrapper input>
              <s.Label size="13px" bold>
                Confirmar nova senha
              </s.Label>
              <InputCadastroSenha
                type="password"
                maxLength="10"
                size="18px"
                icon={<Icon name="key" size={18} />}
                placeholder="Digite novamente uma senha"
                width="45vw"
                height="45"
                disabled={
                  newPassword.length < 8 || newPasswordConfirm.length < 8 || username.length === 0 || code.length === 0
                }
                animate={
                  newPassword.length >= 8 && newPasswordConfirm.length >= 8 && username.length > 0 && code.length > 0
                }
                errorMessage={errorMessagePassword === '' ? `1px ${colors.surfaceMuted} solid` : `1px ${colors.red} solid`}
                value={newPasswordConfirm}
                onChange={(event) => { setNewPasswordConfirm(event.target.value); setErrorMessagePassword('')}}
                newPasswordConfirm
              />
            </s.Wrapper>
            <s.ErrorMessage size="12px" color={colors.red}>
              {errorMessagePassword}
            </s.ErrorMessage>
            <s.ButtonContainer>
              <Button
                type="submit"
                width="45vw"
                maxWidth='450px'
                label="Confirmar"
                color={colors.darkblue}
                background={colors.white}
                hover
                disabled={
                  newPassword.length < 8 || newPasswordConfirm.length < 8
                }
                animate={
                  newPassword.length >= 8 && newPasswordConfirm.length >= 8
                }
              />
              {loading && <Loader />}
            </s.ButtonContainer>
            
        <TipCard icon={icons.LogotipoBlue} paddingTop='20px'/>
        </s.Cmodel>
        <TipPassword/>
      </s.Column>
  );
};

export default withRouter(CadastrarNovaSenha);
